import { Container, Grid, Link, Typography } from '@material-ui/core';
import React from 'react';
import ReturnStepper from './ReturnStepper';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom'
import ReturnsList from './ReturnsList/ReturnsList';
import ReturnDetail from './ReturnsList/ReturnDetail';
import { useTranslation } from 'react-i18next';

const Copyright = () => {
    const { t } = useTranslation()

    return (
        <div style={{ marginTop: 60, marginBottom: 30 }}>
            <Typography variant="body2" color="textSecondary" align="center">
                {t('copyright')} &copy;
                <Link color="inherit" href="https://www.nobelbiocare.com">
                    Nobel Biocare
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        </div>
    );
}

const AppRouter = () =>
    <Router>
        <Switch>
            <Route exact path="/">
                <ReturnsList />
            </Route>
            <Route exact path="/return">
                <ReturnStepper />
            </Route>
            <Route exact path="/order">
                <ReturnDetail />
            </Route>
            <Route exact path="/503">
                <p>Service down</p>
            </Route>
        </Switch>
    </Router>

export default function HUD() {
    const { t }  = useTranslation()
    
    return (
        <>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant='h4' color='primary' style={{ marginBottom: 30, marginTop: 30 }}>{t('nobel_biocare_returns')}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <AppRouter />
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Copyright />
                </Grid>
            </Container>
        </>
    );
}
